import api from './api'

/**
 * Lista e totalizadores vêm na MESMA resposta de propósito: dois endpoints
 * divergiriam no instante em que alguém pagasse entre uma chamada e outra, e um
 * total que não fecha com a lista destrói a confiança na tela inteira.
 */
export async function getCobrancas(eventoId, { situacao = '', q = '' } = {}) {
  const params = {}
  if (situacao) params.situacao = situacao
  if (q) params.q = q
  const { data } = await api.get(`/eventos/${eventoId}/cobrancas`, { params })
  return data
}

export async function registrarPagamentoManual({ pagamentoIds, observacao }) {
  const { data } = await api.post('/pagamentos/manual', { pagamentoIds, observacao })
  return data
}

export const SITUACOES = [
  { valor: '', rotulo: 'Todos' },
  { valor: 'em-dia', rotulo: 'Em dia' },
  { valor: 'atrasados', rotulo: 'Atrasados' },
  { valor: 'quitados', rotulo: 'Quitados' }
]

/** Cores da régua. `vencida` é a única que pede ação. */
export const CORES_PARCELA = {
  paga: 'paga',
  vencida: 'vencida',
  'a-vencer': 'a-vencer',
  cancelada: 'cancelada'
}

export function formatMoney(v) {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v || 0)
}

export function formatDate(d) {
  if (!d) return '—'
  return new Date(d).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })
}
